import Icon from '@/components/ui/AppIcon';

interface SectorFocusCardProps {
  sector: {
    icon: string;
    title: string;
    description: string;
    investmentThesis: string;
    keyInitiatives: string[];
    targetAllocation: string;
  };
}

export default function SectorFocusCard({ sector }: SectorFocusCardProps) {
  return (
    <div className="bg-card rounded-lg shadow-institutional p-4 sm:p-6 border border-border hover:shadow-lg transition-shadow duration-300">
      <div className="flex items-center space-x-1 sm:space-x-2 mb-2 sm:mb-4">
        <div className="flex items-center justify-center w-10 h-10 bg-secondary/10 rounded-lg">
          <Icon
            name={sector.icon as any}
            size={24}
            variant="outline"
            className="text-secondary"
          />
        </div>
        <div className="flex-1">
          <h3 className="font-headline text-xl font-semibold text-foreground">
            {sector.title}
          </h3>
          <p className="font-body text-xs text-muted-foreground">
            Target Allocation: {sector.targetAllocation}
          </p>
        </div>
      </div>

      <p className="font-body text-sm text-text-secondary leading-relaxed mb-2 sm:mb-4">
        {sector.description}
      </p>

      <div className="bg-muted rounded-lg p-2 sm:p-4 mb-2 sm:mb-4">
        <h4 className="font-body text-sm font-bold text-muted-foreground uppercase tracking-wide mb-2">
          Investment Thesis
        </h4>
        <p className="font-body text-sm text-text-primary leading-relaxed">
          {sector.investmentThesis}
        </p>
      </div>

      <div>
        <h4 className="font-body text-sm font-bold  text-muted-foreground uppercase tracking-wide mb-2">
          Key Initiatives
        </h4>
        <ul className="space-y-1 sm:space-y-2">
          {sector.keyInitiatives.map((initiative, index) => (
            <li key={index} className="flex items-start space-x-2">
              <Icon
                name="ArrowRightIcon"
                size={16}
                variant="outline"
                className="text-accent mt-0.5 flex-shrink-0"
              />
              <span className="font-body text-sm text-text-primary">{initiative}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}